import { Component, inject } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { SafeAreaService } from '../utilities/services/safe-area.service';
import { SpinnerService } from '../utilities/services/spinner.service';
import { SelectorDataService } from '../utilities/services/selector-data.service';
import { ClientsService } from '../utilities/services/clients.service';
import { CapacitorHttpHelper } from '../utilities/helper/capacitor-http.helper';
import { ScaniaSpinnerComponent } from '../components/scania-spinner/scania-spinner.component';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet, ScaniaSpinnerComponent],
})
export class AppComponent {
  // Inyectar el servicio para que se inicialice automáticamente
  private safeAreaService = inject(SafeAreaService);
  private spinnerService = inject(SpinnerService);
  private selectorDataService = inject(SelectorDataService);
  private clientsService = inject(ClientsService);

  constructor() {
    // Forzar la inicialización del safe area
    console.log('🚀 App iniciado, safe area:', this.safeAreaService.getCurrentSafeAreaInsets());
    
    // Inicializar CapacitorHttpHelper con SpinnerService
    CapacitorHttpHelper.initSpinnerService(this.spinnerService);

    // Inicializar servicio de datos de selectores (carga desde servidor SIEMPRE al iniciar)
    this.selectorDataService.initialize().catch(error => {
      console.error('❌ Error inicializando servicio de datos de selectores:', error);
    });

    // Precarga el JSON de clientes en background para que el buscador responda
    // de forma inmediata sin esperar a que el usuario abra la pantalla de cesión.
    this.clientsService.preload();
  }
}
